import { z } from "zod";
const booleanString = z.enum(["true", "false"]).transform((value) => value === "true");
export const environmentSchema = z.object({
    NODE_ENV: z.enum(["development", "test", "production"]).default("development"),
    APP_NAME: z.string().default("AgriFlow"),
    APP_SHORT_NAME: z.string().default("AgriFlow"),
    APP_DESCRIPTION: z.string().default("Gestion moderne des exploitations agricoles"),
    APP_VERSION: z.string().default("0.1.0"),
    APP_BASE_URL: z.string().url().default("http://localhost:3100"),
    API_BASE_URL: z.string().url().default("http://localhost:3101"),
    SUPPORT_EMAIL: z.string().email().default("support@example.invalid"),
    API_PORT: z.coerce.number().int().min(1).max(65535).default(3101),
    DATABASE_URL: z.string().min(1),
    IDENTITY_PROVIDER: z.enum(["development", "mammouth"]).default("development"),
    ALLOW_DEVELOPMENT_AUTH: booleanString.default("false"),
    SESSION_SECRET: z.string().min(32),
    SESSION_COOKIE_NAME: z.string().regex(/^[a-z0-9_]+$/).default("agriflow_session"),
    SESSION_TTL_SECONDS: z.coerce.number().int().min(300).max(86400).default(28800),
    LOG_LEVEL: z.enum(["debug", "info", "warn", "error", "fatal"]).default("info"),
    LOCAL_STORAGE_PATH: z.string().default("./storage/development"),
    MAX_UPLOAD_SIZE_MB: z.coerce.number().positive().max(100).default(20),
    MAMMOUTH_API_URL: z.string().url().optional(),
    MAMMOUTH_INTEGRATION_ENABLED: booleanString.default("false")
}).superRefine((value, context) => {
    if (value.NODE_ENV === "production" && value.IDENTITY_PROVIDER === "development") {
        context.addIssue({ code: z.ZodIssueCode.custom, message: "Development identity is forbidden in production", path: ["IDENTITY_PROVIDER"] });
    }
    if (value.IDENTITY_PROVIDER === "development" && !value.ALLOW_DEVELOPMENT_AUTH) {
        context.addIssue({ code: z.ZodIssueCode.custom, message: "Development identity requires explicit opt-in", path: ["ALLOW_DEVELOPMENT_AUTH"] });
    }
    if (value.IDENTITY_PROVIDER === "mammouth" && !value.MAMMOUTH_INTEGRATION_ENABLED) {
        context.addIssue({ code: z.ZodIssueCode.custom, message: "Mammouth identity requires explicit integration opt-in", path: ["MAMMOUTH_INTEGRATION_ENABLED"] });
    }
    if (value.IDENTITY_PROVIDER === "mammouth" && !value.MAMMOUTH_API_URL) {
        context.addIssue({ code: z.ZodIssueCode.custom, message: "MAMMOUTH_API_URL is required with Mammouth identity", path: ["MAMMOUTH_API_URL"] });
    }
});
export function parseEnvironment(input) {
    return environmentSchema.parse(input);
}
export const product = {
    slug: "agriflow",
    module: "agriculture"
};
